import sliderImg1 from '../assets/images/slider/slider-gun.svg'

//search data image 
import rifles from '../assets/images/search/rifles.svg'
import shotguns from '../assets/images/search/shotguns.svg'
import carbines from '../assets/images/search/carbines.svg'
import machineGuns from '../assets/images/search/machine-guns.svg'
import sniperRifles from '../assets/images/search/sniper-rifles.svg'
import submachineGuns from '../assets/images/search/submachine-guns.svg'
import automaticRifles from '../assets/images/search/automatic-rifles.svg'
import assaultRifles from '../assets/images/search/assault-rifles.svg'
import defenseWeapon from '../assets/images/search/defense-weapons.svg'
import handGun from '../assets/images/search/hand-guns.svg'

//gunSlider data image 
import gunSlider1 from '../assets/images/rifles/rifles-1.svg'
import gunSlider2 from '../assets/images/rifles/rifles-2.svg'
import gunSlider3 from '../assets/images/rifles/rifles-3.svg'
import gunSlider4 from '../assets/images/rifles/rifles-4.svg'
import gunSlider5 from '../assets/images/rifles/rifles-5.svg'
import favouriteIcon from '../assets/images/icons/favourite.svg'

import discountRifles from '../assets/images/discounted-rifles.svg'



export const sliderData = [
    {
        title: 'Brand new Ak47 short Gun',
        sub: '-20% Discount',
        text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry Ipsum has been.',
        link: '/',
        image: sliderImg1,
        buttonText: 'Order Now'
    },
    {
        title: 'CMMG Mutant/MK47',
        sub: '-12% Discount',
        text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry Ipsum has been.',
        link: '/',
        image: machineGuns,
        buttonText: 'Order Now'
    }
]


export const searchData = [
    {title: 'Rifles', img: rifles},
    {title: 'Shotguns', img: shotguns},
    {title: 'Carbines', img: carbines},
    {title: 'Machine guns', img: machineGuns},
    {title: 'Sniper rifles', img: sniperRifles},
    {title: 'Submachine guns', img: submachineGuns},
    {title: 'Automatic rifles', img:automaticRifles},
    {title: 'Assault rifles', img:assaultRifles},
    {title: 'Defense weapons', img:defenseWeapon},
    {title: 'Hand guns', img:handGun},
    
]


export const gunSliderData = [
    {
        id: 1,
        title: 'Ak47 Short Gun',
        category: 'Shortgun',
        price: 1200,
        tag: 'new',
        image: gunSlider1,
        icon: favouriteIcon
    },
    {
        id: 2,
        title: 'Ak47 Short Gun',
        category: 'Shortgun',
        price: 1000,
        tag: 'used',
        image: gunSlider2,
        icon: favouriteIcon
    },
    {
        id: 3,
        title: 'Ak47 Short Gun',
        category: 'Shortgun',
        price: 2200,
        tag: 'new',
        image: gunSlider3,
        icon: favouriteIcon
    },
    {
        id: 4,
        title: 'Ak47 Short Gun',
        category: 'Shortgun',
        price: 1280,
        tag: 'new',
        image: gunSlider4,
        icon: favouriteIcon
    },
    {
        id: 5,
        title: 'Ak47 Short Gun',
        category: 'Shortgun',
        price: 3200,
        tag: 'used',
        image: gunSlider5,
        icon: favouriteIcon
    }
]


export const discountData = [
    {
        id: 1, 
        discountText: '-20% Discount',
        title: 'Discount on Rifles',
        text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry Ipsum has been.',
        link: '/',
        linkText: 'Buy Now',
        bg: '#F0FFE4',
        img: discountRifles
    },
    {
        id: 2, 
        discountText: '-20% Discount',
        title: 'Discount on Shotgun',
        text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry Ipsum has been.',
        link: '/',
        linkText: 'Order Now',
        bg: '#e4f2ff',
    }
]